import { FC } from 'react';

type Props = {
	className?: string;
};

const ViewOffSlashIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M15.9518 12.751C16.6915 12.0167 17.2626 11.287 17.6358 10.7637C17.879 10.4226 18.0006 10.2521 18.0006 9.99964C18.0006 9.74723 17.879 9.57666 17.6358 9.23561C16.5429 7.7031 13.7518 4.39941 10.0003 4.39941C9.27406 4.39941 8.58379 4.52323 7.93486 4.73404M5.79809 5.79741C4.18503 6.88527 2.99376 8.3537 2.36485 9.23561C2.12161 9.57666 2 9.74723 2 9.99964C2 10.2521 2.12161 10.4226 2.36485 10.7637C3.45774 12.2962 6.2488 15.5999 10.0003 15.5999C11.593 15.5999 13.0125 15.0044 14.2026 14.2019'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M8.28788 8.3999C7.86384 8.82392 7.60156 9.40978 7.60156 10.0568C7.60156 11.351 8.65064 12.4001 9.94478 12.4001C10.5918 12.4001 11.1777 12.1378 11.6017 11.7137'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M2.80078 2.7998L17.2014 17.2004'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ViewOffSlashIcon;
